import React, { createContext, useState, useEffect, useContext } from 'react';
import auth from "../services/authService";
import EntityContext from "../context/entityContext";

export const SupplyChainContext = createContext();

export const SupplyChainProvider = ({ children }) => {
  const { constants } = auth.getCurrentUser();
  const productId = constants.PRODUCTS.SUPPLYCHAIN;

  const { entityDetails } = useContext(EntityContext);
 

  const [breadCrumbs, setBreadcrumbs] = useState({});
  const [reloadWidget, setReloadWidget] = useState(false);
  

  return (
    <SupplyChainContext.Provider
      value={{ breadCrumbs, setBreadcrumbs, productId, reloadWidget, setReloadWidget, entityDetails }}
    >
      {children}
    </SupplyChainContext.Provider>
  );
};
